import {
  OverlayAnchorElement,
  OverlayPositionerElement,
  OverlayRootElement,
  overlayAnchorEvents,
  overlayAnchorProps,
  overlayPositionerEvents,
  overlayPositionerProps,
  overlayRootEvents,
  overlayRootProps
} from "./chunk-BWKVXDM4.js";

// src/index.ts
import { registerCustomElement } from "@aria-ui/core";
registerCustomElement("aria-ui-overlay-anchor", OverlayAnchorElement);
registerCustomElement("aria-ui-overlay-positioner", OverlayPositionerElement);
registerCustomElement("aria-ui-overlay-root", OverlayRootElement);
export {
  overlayAnchorEvents,
  overlayAnchorProps,
  overlayPositionerEvents,
  overlayPositionerProps,
  overlayRootEvents,
  overlayRootProps
};
